import React, { useState, useEffect } from "react";
import Header from "../../../layout/Header";
import Sidebar from "../../../layout/Sidebar";
import { Table, Collapse } from "antd";
import moment from "moment";
import Bridge from "../../../constants/Bridge";
import Strings from "../../../constants/Strings";
import Synopsis from "./Synopsis";
import $ from "jquery";

const List = () => {
  const [paginationNum, setPaginationNum] = useState(10);
  const [allForms, setAllForms] = useState([]);
  const [copyOfAllForms, setCopyOfAllForms] = useState([]);
  const [tableloader, setTableloader] = useState(false);
  const [totalParticipantCount, setTotalParticipantCount] = useState(0);
  const [needtoupgrade, setNeedtoupgrade] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const handleTableChange = (pagination, filters, sorter) => {
    setPaginationNum(pagination.pageSize);
  };
  const ColumnsForPHI = [
    {
      title: "Neurostamp Id",
      dataIndex: "nuerostampId",
      key: "nuerostampId",
      width: window.innerWidth > 650 ? 80 : 40,
      fixed: window.innerWidth > 650 ? "left" : false,
      render: (text) => {
        return (
          <div style={{ display: "flex" }}>
            {text.neurostamp_id ? text.neurostamp_id : "---"}
            {text.controls && text.als ? (
              <div className="participant-icon ml-2">ALS</div>
            ) : (
              <>
                {text.controls && (
                  <div className="participant-icon ml-2">C</div>
                )}
                {text.als && <div className="participant-icon ml-2">ALS</div>}
              </>
            )}
          </div>
        );
      },
    },
    {
      title: "Date Submitted",
      dataIndex: "dateSubmitted",
      key: "dateSubmitted",
      width: 70,
      fixed: window.innerWidth > 650 ? "left" : false,
    },
    {
      title: "Language (28)",
      dataIndex: "language_score",
      key: "language_score",
      width: 60,
    },
    {
      title: "Verbal Fluency (24)",
      dataIndex: "verbal_fluency_score",
      key: "verbal_fluency_score",
      width: 70,
    },
    {
      title: "Executive (48)",
      dataIndex: "executive_score",
      key: "executive_score",
      width: 60,
    },
    {
      title: "ALS SPECIFIC Score (100)",
      dataIndex: "als_specific_score",
      key: "als_specific_score",
      width: 80,
    },
    {
      title: "Memory Score (24)",
      dataIndex: "memory_score",
      key: "memory_score",
      width: 80,
    },
    {
      title: "Visuospatial Score (12)",
      dataIndex: "visuospatial_score",
      key: "visuospatial_score",
      width: 80,
    },
    {
      title: "ALS NON SPECIFIC Score (36)",
      dataIndex: "als_non_specific_score",
      key: "als_non_specific_score",
      width: 100,
    },
    {
      title: "ECAS Score (136)",
      dataIndex: "ecas_total_score",
      key: "ecas_total_score",
      width: 70,
      fixed: window.innerWidth > 650 ? "right" : false,
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: 40,
      fixed: window.innerWidth > 650 ? "right" : false,
      render: (item) => {
        return (
          <div style={{ width: "100%" }}>
            <a href={`/ecas-view?ID=${item.ecas_forms_id}`} target="_blank">
              <i
                className="fas fa-eye"
                style={{ fontSize: 18, paddingLeft: 6 }}
              ></i>
            </a>
          </div>
        );
      },
    },
  ];
  const get_all_ecas_forms = () => {
    setTableloader(true);
    Bridge.ecas
      .list()
      .then((result) => {
        if (result.status == "1") {
          setAllForms(result.data);
          setCopyOfAllForms(result.data);
          setTotalParticipantCount(result.count);
          setTableloader(false);
        } else if (result.status == "4") {
          let list = [
            {
              ecas_forms_id: 0,
              participants_id: 0,
              neurostamp_id: "NST0000001",
              submitted_date: "7th Nov 2023, 6:44:49 PM GMT+0530",
              total_language_score: 0,
              total_verbal_fluency_score: 0,
              total_executive_score: 0,
              total_als_specific_score: 0,
              total_memory_score: 0,
              total_visuospatial_score: 0,
              total_als_non_specific_score: 0,
              ecas_total_score: 0,
              date_created: "2022-01-03T00:13:23.000Z",
              ecas_date: "2023-11-07T07:45:43.000Z",
              als: "1",
              controls: "",
            },
            {
              ecas_forms_id: 1,
              participants_id: 1,
              neurostamp_id: "NST0000002",
              submitted_date: "7th Nov 2023, 6:44:49 PM GMT+0530",
              total_language_score: 0,
              total_verbal_fluency_score: 0,
              total_executive_score: 0,
              total_als_specific_score: 0,
              total_memory_score: 0,
              total_visuospatial_score: 0,
              total_als_non_specific_score: 0,
              ecas_total_score: 0,
              date_created: "2022-01-03T00:13:23.000Z",
              ecas_date: "2023-11-07T07:45:43.000Z",
              als: "1",
              controls: "",
            },
          ];
          setAllForms(list);
          setNeedtoupgrade(true);
          setTotalParticipantCount(result.count);
          setTableloader(false);
        } else {
          setTableloader(false);
        }
      })
      .catch((error) => {
        setTableloader(false);
      });
  };
  useEffect(() => {
    if ($(window).width() < 600) {
      console.log("window::", window);
      $("#sidebar").removeClass("show-sidebar").addClass("hide-sidebar");
    } else {
      $("#sidebar").removeClass("hide-sidebar").addClass("show-sidebar");
    }
    get_all_ecas_forms();
  }, []);
  const dataSource =
    allForms &&
    allForms.map((item, index) => {
      let splitted_date = item.ecas_date.split("T")[0];
      return {
        key: index,
        nuerostampId: item,
        ecas_total_score: item.ecas_total_score ? item.ecas_total_score : "---",
        dateSubmitted: item.ecas_date
          ? moment(splitted_date).format("MM/DD/YYYY")
          : "---",
        language_score: item.total_language_score
          ? item.total_language_score
          : "0",
        verbal_fluency_score: item.total_verbal_fluency_score
          ? item.total_verbal_fluency_score
          : "0",
        executive_score: item.total_executive_score
          ? item.total_executive_score
          : "0",
        als_specific_score: item.total_als_specific_score
          ? item.total_als_specific_score
          : "0",
        memory_score: item.total_memory_score ? item.total_memory_score : "0",
        visuospatial_score: item.total_visuospatial_score
          ? item.total_visuospatial_score
          : "0",
        als_non_specific_score: item.total_als_non_specific_score
          ? item.total_als_non_specific_score
          : "0",
        ecas_total_score: item.ecas_total_score ? item.ecas_total_score : "0",
        action: item,
      };
    });
  const onChangeTab = (key) => {
    // console.log(key);
  };
  const items = [
    {
      key: "1",
      label: "Synopsis",
      children: (
        <div className="accordion-content">
          <p>
            <Synopsis />
          </p>
        </div>
      ),
    },
  ];
  return (
    <div>
      <Header />
      <div className="row">
        <Sidebar />
        <div
          className="col-lg-10"
          style={{
            marginLeft: "auto",
            backgroundColor: "#F5F5F5",
          }}
        >
          <div
            className="wrapper clearfix records-wrapper top-space"
            style={{ margin: 0, boxShadow: "none" }}
          >
            <div className="multisteps-form">
              <div className="row">
                <div className="col-12 col-lg-12 m-auto ecas-table">
                  <div className="ambassador-heading-section mb-2">
                    <h3 className="section-heading" style={{ fontSize: 31 }}>
                      {Strings.ecasSessions} - (Total Participants:{" "}
                      {totalParticipantCount}, Total Sessions: {allForms.length}
                      )
                    </h3>
                  </div>
                  <div className="synopsis-accordion">
                    <div className="row" style={{ padding: "2%" }}>
                      <Collapse
                        items={items}
                        defaultActiveKey={[]}
                        onChange={onChangeTab}
                      />
                    </div>
                  </div>
                  <div className="all-participant-list ecas-list">
                    {needtoupgrade == true && (
                      <div className="background-overlay">
                        <div className="row px-0">
                          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div className="need-to-upgrade-wrapper">
                              <div className="inner-ui">
                                <h4>Upgrade to Platinum to access all data</h4>
                                <p>
                                  Contact Christian Rubio{" "}
                                  <a
                                    style={{ color: "#007dfc" }}
                                    href="mailto:christian@everythingals.org"
                                  >
                                    christian@everythingals.org
                                  </a>{" "}
                                  to learn more about Platinum membership and
                                  how to upgrade
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="content">
                      <div className="ecas-form-list">
                        <Table
                          dataSource={dataSource}
                          loading={tableloader}
                          pagination={{ pageSize: paginationNum }}
                          columns={ColumnsForPHI}
                          scroll={{ x: window.innerWidth > 650 ? 1950 : 1500 }}
                          onChange={handleTableChange}
                        />
                      </div>
                    </div>
                  </div>

                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default List;
